import { DIETER_INFO } from "../../constants/foodmenu";

const DietaryBadges = ({ dietaryRestrictions }) => {
    if (!dietaryRestrictions) return null;

    const restrictions = dietaryRestrictions
        .split(",")
        .map((item) => item.trim())
        .filter((item) => item && DIETER_INFO[item]);

    if (restrictions.length === 0) return null;

    return (
        <>
            {restrictions.map((restriction) => {
                const info = DIETER_INFO[restriction];
                return (
                    <div
                        key={restriction}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            backgroundColor: info.bgColor,
                            padding: "2px 8px",
                            borderRadius: "12px",
                        }}
                    >
                        {info.icon}
                        <span
                            style={{
                                fontSize: "12px",
                                fontWeight: 500,
                                color: info.color,
                                lineHeight: "16px",
                            }}
                        >
                            {info.label}
                        </span>
                    </div>
                );
            })}
        </>
    );
};

export default DietaryBadges;
